/* ============================================
 * Keyboard navigation for mega menu tab panels
 * ============================================ */
document.addEventListener('keydown', (e) => {
  if (e.key !== 'Tab') return;

  const activeTab = document.querySelector('.mega-menu-tabbed__tab--is-active');
  if (!activeTab || activeTab.dataset.hasLinks !== 'true') return;

  const container = activeTab.closest('.snippet-tabbed');
  const panel = container?.querySelector(`.mega-menu-tabbed__panel[data-panel="${activeTab.dataset.panel}"]`);
  if (!panel || panel.hidden) return;

  const focusable = Array.from(panel.querySelectorAll('a, button, [tabindex]:not([tabindex="-1"])'));
  if (!focusable.length) return;

  const current = document.activeElement;
  const first = focusable[0];
  const last = focusable[focusable.length - 1];
  const tabs = Array.from(container.querySelectorAll('.mega-menu-tabbed__tab'));
  const nextTab = tabs[tabs.indexOf(activeTab) + 1];

  if (!e.shiftKey && current === activeTab) {
    e.preventDefault();
    first.focus();
  } else if (!e.shiftKey && current === last && nextTab) {
    e.preventDefault();
    nextTab.focus();
    nextTab.dispatchEvent(new FocusEvent('focus'));
  } else if (e.shiftKey && current === first) {
    e.preventDefault();
    activeTab.focus();
  }
});
